import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ProtectedRoutes from '../protected-routes/protected-routes';
import { useSelector } from 'react-redux';
import NotFound from '../../../layouts/not-found/not-found';
import PublicRoutes from '../public-routes/public-routes';

const PageRouter = () => {
  const userDetails = useSelector((state) => state?.userState?.user);
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        {ProtectedRoutes(userDetails?.authenticated)}
        {PublicRoutes(userDetails?.authenticated)}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default PageRouter;
